import { render, staticRenderFns } from "./ZPButtonList.vue?vue&type=template&id=31bda6b0&scoped=true"
import script from "./ZPButtonList.vue?vue&type=script&lang=js"
export * from "./ZPButtonList.vue?vue&type=script&lang=js"
import style0 from "./ZPButtonList.vue?vue&type=style&index=0&id=31bda6b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bda6b0",
  null
  
)

export default component.exports